import React, { useEffect, useState } from 'react'
import whatsappApi from './whatsappApi'
import myToast from '../../Utils/MyToast'

const WhatsAppPricePlansPanel = () => {
  const [plans, setPlans] = useState([])
  const [subPlans, setSubPlans] = useState([])
  const [minRecharge, setMinRecharge] = useState(500)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    whatsappApi
      .getPricePlans()
      .then((res) => {
        if (res.api_status === 'OK') {
          setPlans(res.data.plans || [])
          setSubPlans(res.data.subscription_plans || [])
          setMinRecharge(res.data.min_recharge || 500)
        } else {
          myToast.notify_error(res.api_remark || 'Failed to load plans')
        }
      })
      .catch(() => myToast.notify_error('Failed to load price plans'))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div style={{ padding: '12px 4px' }}>
      <p style={{ color: '#4b5563', maxWidth: 640 }}>
        Subscription plans include a monthly message allowance. Rates below are{' '}
        <strong>overage platform fees</strong> charged from your EduOK wallet only after
        the allowance is used up. Minimum recharge: ₹{minRecharge}.
      </p>

      {loading ? (
        <div className="text-muted">Loading…</div>
      ) : (
        <>
          {subPlans.length > 0 && (
            <div className="table-responsive mb-4" style={{ maxWidth: 720 }}>
              <h6 style={{ fontWeight: 800 }}>Subscription plans</h6>
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    <th>Plan</th>
                    <th>Monthly fee</th>
                    <th>Included messages</th>
                  </tr>
                </thead>
                <tbody>
                  {subPlans.map((p) => (
                    <tr key={p.id}>
                      <td>{p.plan_name}</td>
                      <td>₹{Number(p.monthly_fee).toFixed(2)}</td>
                      <td>{Number(p.included_messages).toLocaleString('en-IN')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="table-responsive" style={{ maxWidth: 720 }}>
            <h6 style={{ fontWeight: 800 }}>Overage rates</h6>
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th>Plan</th>
                  <th>Category</th>
                  <th>Overage / message</th>
                </tr>
              </thead>
              <tbody>
                {plans.map((p) => (
                  <tr key={p.id}>
                    <td>{p.plan_name}</td>
                    <td style={{ textTransform: 'capitalize' }}>{p.conversation_category}</td>
                    <td>
                      ₹
                      {Number(p.overage_price_per_message ?? p.price_per_message).toFixed(4)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

export default WhatsAppPricePlansPanel
